import { FileText, Loader2 } from "lucide-react";

interface ReopeningDigestCtaProps {
  /** true = no digest yet; false = digest exists but is hidden for viewer */
  isNew: boolean;
  loading: boolean;
  onGenerate: () => void;
  onReopen: () => void;
}

/**
 * Compact call-to-action shown above the thread list when:
 * - feature is enabled AND clinic is open
 * - AND no visible digest row exists (either never generated or hidden by viewer)
 */
export default function ReopeningDigestCta({
  isNew,
  loading,
  onGenerate,
  onReopen,
}: ReopeningDigestCtaProps) {
  return (
    <div className="mx-3 my-2 px-3 py-2.5 rounded-lg bg-teal-50 border border-teal-200 flex items-center gap-2.5">
      <div className="shrink-0 w-7 h-7 rounded-md bg-teal-100 flex items-center justify-center">
        <FileText className="w-3.5 h-3.5 text-teal-600" strokeWidth={1.75} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold text-teal-800 leading-snug">
          {isNew ? "Clinic just reopened" : "Digest available"}
        </p>
        <p className="text-[11px] text-teal-600 leading-snug truncate">
          {isNew
            ? "Generate a digest of missed conversations"
            : "You previously hid today's digest"}
        </p>
      </div>
      <button
        type="button"
        disabled={loading}
        onClick={isNew ? onGenerate : onReopen}
        className="shrink-0 flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium rounded-md bg-teal-600 text-white hover:bg-teal-700 disabled:opacity-60 transition-colors"
      >
        {loading && <Loader2 className="w-3 h-3 animate-spin" />}
        {isNew ? "Get digest" : "Open digest"}
      </button>
    </div>
  );
}
